import type { NormalStep } from './steps.types';

export function normaliseSteps(raw: any): NormalStep[] {
  const rows = Array.isArray(raw) ? raw : [];
  return rows.map((s: any, i: number) => ({
    stepKey: s.stepKey ?? `step-${i}`,
    title: s.name ?? s.stepKey ?? 'Step',
    description: s.description,
    phaseKey: s.phaseKey ?? 'general',
    // Authored phase label from the published workflow when the BFF joined
    // program-config; title-cased phaseKey only as a fallback (the ticket
    // forbids portal-invented names whenever the authored one exists).
    phaseName: s.phaseName ?? prettyPhase(s.phaseKey),
    phaseOrder: typeof s.phaseOrder === 'number' ? s.phaseOrder : null,
    authoredPhaseName: s.phaseName != null,
    status: s.isCompleted ? 'completed' : s.flagState && s.flagState !== 'none' ? s.flagState : 'not_started',
    globusMessage: (s.applicantMessages ?? [])[0]?.message ?? (s.applicantMessages ?? [])[0],
    stepConfig: s.stepConfig,
    stepData: s.stepData,
    needsAction: s.needsAction,
    rejectionMessage: s.rejectionMessage,
    rejectionCode: s.rejectionCode,
    documentReviewStatus: s.documentReviewStatus,
    complianceFeedback: Array.isArray(s.complianceFeedback) ? s.complianceFeedback : null,
    // Hub step wiring (Asana 1216802150410999): propagate the structural
    // node type and sub-task map so ApplicationPage can build HubChecklistData.
    nodeType: s.nodeType ?? undefined,
    hubSubtaskMap: Array.isArray(s.hubSubtaskMap) ? s.hubSubtaskMap : undefined,
    journeyPositionKey: s.journeyPositionKey ?? null,
  }));
}

const prettyPhase = (k?: string) =>
  (k ?? 'Application').replace(/[_-]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
